import { ThinScanner } from '@frontend/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import useOnboardScanner from './onboard-scanner.controller';

const ID = 'onboard-scanner';
export interface OnboardScannerProps {
    callback?: (value: string) => void;
    disabled?: boolean;
}

export const OnboardScanner = (props: OnboardScannerProps) => {
    const viewProps = useOnboardScanner(props);

    return (
        <div
            id={ID}
            className='bg-brand-secondary flex h-full w-full flex-col justify-center'>
            <div className='text-background-surface relative h-1/4'>
                <ThinScanner className='size-full self-center align-middle' />
                <p className='text-background-surface absolute inset-0 flex items-center justify-center text-center text-xl font-semibold'>
                    {viewProps.value === '' ? (
                        <FormattedMessage
                            id='onboard.scanner.title'
                            description='Text displayed when using the onboard scanner'
                            defaultMessage='Use the scanner'
                        />
                    ) : (
                        <FormattedMessage
                            id='onboard.scanner.title-while-processing'
                            description='Text displayed when using the onboard scanner when something was scanned'
                            defaultMessage='Processing...'
                        />
                    )}
                </p>
            </div>
        </div>
    );
};

export default OnboardScanner;
